import 'air-datepicker/dist/js/datepicker';
import 'air-datepicker/dist/js/i18n/datepicker.en';

const init = () => {
	const $dateInput = $('.js-datepicker');

	if (!$dateInput.length) {
		return;
	}

	// Make Sunday, Tuesday, Wednesday and Thursday disabled
	var disabledDays = [
		0, // Sunday
		2, // Tuesday
		3, // Wednesday
		4, // Thursday
	];

	const extraDates = $dateInput.data('extra-dates').split(' ');
	const disabledDates = $dateInput.data('disabled-dates').split(' ');

	const minDate = new Date();

	// Set the minimum start date to tomorrow
	minDate.setDate(minDate.getDate() + 1);

	// Set the minimum start date to today if before 2pm
	if (minDate.getHours() < 14) {
		minDate.setDate(minDate.getDate() - 1);
	}

	$dateInput.datepicker({
		language: 'en',
		dateFormat: 'dd-mm-yyyy',
		minDate: minDate,
		firstDay: 1,
		onRenderCell: function (date, cellType) {
			if (cellType == 'day') {
				var day = date.getDay(),
				isDisabled = disabledDates.indexOf(toInternationalDate(date)) !== -1
				||  (
					disabledDays.indexOf(day) != -1
					&& extraDates.indexOf(toInternationalDate(date)) === -1
				);

				return {
					disabled: isDisabled
				}
			}
		},
		onSelect: function (formattedDate, date, inst) {
			processNights(formattedDate);
		}
	});

	// Save the original state
	const $nightSelect = $('#AvailabilitySearchNights');
	$nightSelect.data('allOptions', $nightSelect.html());

	// If the input has a value select that date
	const dateValue = $dateInput.val();
	if (dateValue.match(/\d{2}\-\d{2}\-\d{4}/)) {
		$dateInput.data('datepicker').selectDate(getDateFromString(dateValue));
	} else {
		processNights(null);
	}
}

/**
 * Enables and disables the number of nights options based on the date selected
 *
 * @param string date
 */
function processNights(date) {
	const selectedDay = getDayOfWeek(date);
	const $nightSelect = $('#AvailabilitySearchNights');
	const $nightOptions = $($nightSelect.data('allOptions'));

	$nightSelect.empty().append($nightOptions);

	// Loop over available nights options and only
	// show the ones that are available
	if (selectedDay) {
		$nightOptions.each(function() {
			const $this = $(this),
				  option = Object.getOwnPropertyNames($this.data()),
				  extraDates = $this.data('allow-dates'),
				  disabledDates = $this.data('disable-dates');

			if (
				$this.val() != "" &&
				(
					(
						option.indexOf(selectedDay) === -1 &&
						(!extraDates || extraDates.indexOf(toInternationalDate(date)) === -1)
					) ||
					(disabledDates && disabledDates.indexOf(toInternationalDate(date)) !== -1)
				)
			) {
				$this.remove();
			}
		});
	// If no date is available show all the options
	} else {
		$nightOptions.each(function() {
			const $this = $(this);
			if ($this.is(':not([value=""],[data-monday],[data-friday],[data-saturday])')) {
				$this.remove();
			}
		})
	}

	// Check that the currently selected number of nights is allowed.
	const $currentNights = $nightOptions.filter(':selected').attr('disabled');

	// If the previous selected option is no longer enabled reset the input to 'Please Select...'
	if ($currentNights !== undefined) {
		$nightSelect.val('');
	}
}

/**
 * Gets the day of the week as a string for a given date
 *
 * @param string date
 */
function getDayOfWeek(date) {
	if (!date) {
		return null;
	}
	const dayOfWeek = getDateFromString(date).getDay();
	return isNaN(dayOfWeek) ? null : ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayOfWeek];
}

/**
 * Returns a date from a string in DD-MM-YYYY format
 *
 * @param string date
 * @return Date
 */
function getDateFromString(date) {
	if (!date) {
		return null;
	}
	const [day, month, year] = date.split('-');
	return new Date(year, month - 1, day);
}

/**
 * Converts a date to a YYYY-MM-DD format string
 *
 * @param Date|string date object or string of date in DD-MM-YYYY format
 * @return date
 */
function toInternationalDate(date) {
	if (!date) {
		return null;
	}
	// If we've been passed a string convert it to a date
	if (!(date instanceof Date)) {
		date = getDateFromString(date);
	}
	return date.getFullYear() + '-' +
		(date.getMonth() + 1).toString().padStart(2, '0') + '-' +
		date.getDate().toString().padStart(2, '0');
}

init();
